import { useState, useEffect } from "react";
import Image from "next/image";

const Testimonials = ({ category }) => {
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    import(`../data/testimonials/${category}.js`)
      .then((module) => setTestimonials(module.testimonials))
      .catch((error) => console.error("Error loading testimonials:", error));
  }, [category]);

  const [currentIndex, setCurrentIndex] = useState(0);

  if (testimonials.length === 0) return <p>Loading testimonials...</p>;

  const nextTestimonial = () => setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  const prevTestimonial = () => setCurrentIndex((prev - 1 + testimonials.length) % testimonials.length);

  return (
      <section className="relative overflow-hidden">
      {/* ✅ Background image rendered lazily */}
      <div className="absolute inset-0 z-0">
        <Image
          src={`/testimonials/${category}/best-home-remodling-contractor-in-los-angeles.webp`}
          alt="Client testimonial background"
          fill
          className="object-cover"
          sizes="100vw"
          priority={false} // Lazy-load this image
        />
        <div className="absolute inset-0 bg-black opacity-60"></div>
      </div>

      {/* Content over image */}
      <div className="relative z-10 text-white py-20 px-8 max-w-4xl mx-auto">
        <h2 className="text-sm font-light mb-2 tracking-[5px] uppercase">Testimonials</h2>
        <h3 className="text-3xl font-base mb-3 font-gilda">What Clients Say?</h3>
        <span className="block h-[1px] mb-3 bg-opacity-30 w-[55px] bg-white"></span>
        
        <div className="relative h-90 lg:h-56 overflow-visible">
          <div className="flex transition-transform duration-500 ease-in-out"
            style={{ transform: `translateX(-${currentIndex * 100}%)`, width: `${testimonials.length * 100}%` }}
          >
            {testimonials.map((testimonial, index) => (
              <div key={index} className="flex-shrink-0 w-full max-w-full">
                <p className="text-md text-justify mb-6 italic font-light break-words w-[33%] lg:max-w-3xl">
                  {testimonial.text}
                </p>
                <div className="flex items-center mb-6">
                  <Image 
                    src={testimonial.photo} 
                    alt={`${testimonial.name} recommends Modern Build as Los Angeles Best ${testimonial.service} Contractor`}
                    title={`${testimonial.name} recommends Modern Build as Los Angeles Best ${testimonial.service} Contractor`}
                    width={64} 
                    height={64} 
                    className="w-16 h-16 rounded-full mr-4 border-2 border-white"
                  />
                  <div>
                    <div className="flex mb-1 mt-1">
                      {Array.from({ length: testimonial.rating }).map((_, i) => (
                        <svg key={i} xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-yellow-500 mr-1" viewBox="0 0 20 20" fill="currentColor">
                          <path d="M10 15l-3.5 2 1-4.5-3.5-3h4.5L10 4l2 5.5h4.5l-3.5 3 1 4.5L10 15z" />
                        </svg>
                      ))}
                    </div>
                    <h4 className="text-md mb-1 font-light tracking-[3px] uppercase">{testimonial.name}</h4>
                    <p className="text-sm font-light">{testimonial.rating}-Star Rating / Publish on {testimonial.date}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Navigation */}
        <div className="flex justify-center mt-4">
          {testimonials.map((_, index) => (
            <button
              aria-label="Next Slide"
              key={index}
              className={`h-3 w-3 rounded-full mx-2 border ${currentIndex === index ? 'bg-primary border-primary' : 'bg-transparent border-white'}`}
              onClick={() => setCurrentIndex(index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
